<template>
  <v-app-bar
    app text dark clipped-left
    class="bg-dark"
    :class="[{pr1: $mq.md_sm, relative: !$mq.md}]"
    >

    <div class="circuit-background absolute bottom-0 m0" style="left: 0px;"></div>
    <div class="flex" style="max-width: 250px">
      <LogoLens class="fit" style="margin-left: 10px; height: 28px" />
    </div>

    <transition-group
      name="slide-x-transition"
      class="flex align-center toolbar-transition-group pl2"
      >
      <v-btn
        icon
        v-if="shouldRenderBackButton"
        @click="$router.back()"
        :ripple="false"
        key="button"
        style="margin-left: -4px;"
        >
        <v-icon>arrow_back</v-icon>
      </v-btn>

      <v-toolbar-title key="title" :class="$mq.md_sm ? 'ml1' : 'ml0' ">
      <div style="">
        <span v-if="sysAdmin" class="sys_admin role">[System Admin] </span> {{organizationName}}
      </div>
      </v-toolbar-title>
    </transition-group>

    <v-spacer />

    <Search v-if="$mq.md_sm" />

    <slot />

  </v-app-bar>
</template>


<script>
/* @flow */
import LogoLens from '@/components/LogoLens'
import Search from '@/components/Search'
import {orgAdmin, sysAdmin} from '@/utils/api'

export default {
  name: 'Topbar',
  extends: {
    computed: {
      sysAdmin,
      orgAdmin,
    },
  },
  props: {
    routePath: {
      type: String,
      default: '',
    },
  },
  computed: {
    organizationName() {
      return this.$store.getters.currentOrganization.name
    },
    shouldRenderBackButton() {
      const pathArray = this.routePath.split('/')
      if (pathArray.length > 2 && pathArray[2] !== 'new') {
        return true
      }
      return false
    },
  },
  components: {
    LogoLens,
    Search,
  },
}
</script>

<style scoped>
.sys_admin.role {
  color: red;
}

.circuit-background {
  background: url('../assets/img/circuit-board-background.png');
  background-position: 0 -35px;
  height: 12px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Topbar.vue